// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eda418cf","239":"6fe2aa1f","453":"88b7b595","455":"2df99fae"}[chunkId] + ".chunk.js";
};